import React from 'react';
import { ReviewType } from '../../components/libs/typeInterface';
import ProductReviews from './ProductReviews';
import ProductQA from './ProductsQA';

interface IProductReviewContainer {
  rating: number;
  reviews: ReviewType[];
  verifiedUser: number;
  link: string;
}
const ProductReviewContainer = (props: IProductReviewContainer) => {
  const { rating, reviews, verifiedUser, link } = props;
  const [isReviews, setReviews] = React.useState(true);
  return (
    <>
      <section className="xs:px-4 lg:px-0 relative w-full flex flex-col items-center justify-center lg:container lg:mx-auto xs:mb-5">
        <div className="w-full flex flex-col pt-10">
          <div className="w-full flex flex-row border-b-2 border-borderColor">
            <a
              onClick={() => setReviews(true)}
              className={`cursor-pointer relative pb-3 px-5 text-base text-center hover:text-customColors-300 border-transparent${
                isReviews ? ' text-customColors-300 tb-active' : ' text-secondary'
              }`}
            >
              Ratings & Reviews
            </a>
            {/* <a
              onClick={() => setReviews(false)}
              className={`cursor-pointer relative pb-3 px-5 text-base text-center hover:text-customColors-300 border-transparent${
                isReviews ? ' text-secondary' : ' text-customColors-300 tb-active'
              }`}
            >
              Product Q&A
            </a> */}
          </div>
          <div className="w-full">
            {isReviews ? (
              <ProductReviews
                rating={rating}
                reviews={reviews}
                verifiedUser={verifiedUser}
                link={link}
              />
            ) : (
              <ProductQA />
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductReviewContainer;
